import { Pipe, PipeTransform } from '@angular/core';
import { ContextService } from './context.service';

@Pipe({
  name: 'substitution',
  standalone: false
})
export class SubstitutionPipe implements PipeTransform {
  constructor( private context : ContextService) {
  }

  transform(value: unknown, ...args: unknown[] ): string {
    if (!value) { return (value ?? '')?.toString(); };
    
    let strValue: string = value?.toString(), source = args?.[0] ?? this.context.config.defaults;
    try {
      let matches = strValue.match(/{{[\-_\w]+}}/g);
      if (!!matches) {
        try {
          matches.forEach(matchValue => {
            strValue = strValue.replace(matchValue, source[ matchValue?.slice(2, -2)] ?? '');
          });
        } catch (error) {
          console.error('Failed match %\n%O', value, error);
        }
      }
    } catch (err) {
      console.error("Binding %O error -> %O", typeof value, err);
    }

    return strValue;
  }
}

